import React, { useState } from 'react'
import CommonSEOTitle from '../../../../helpers/CommonSEOTitle'
import AccountNavigation from '../Navigation/AccountNavigation'
import { Col, FormLabel, Row } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { useGetProfile } from '@hooks';
import { onDefaultError } from '../../../../helpers/commonHelpers'

const ContactAdditionalInfo = ({ t }) => {
      const navigate = useNavigate();
        const [data, setData] = useState({});

        const { refetch, isLoading } = useGetProfile(
            ({ data: profile }) => {
                if (profile) {
                    setData(profile);
                }
            },
            (error) => {
                onDefaultError(error);
            }
        );

    return (
        <>
        {data && Object.keys(data).length > 0 ? (

                <>
            <CommonSEOTitle title={t('page.contact_&_additional_info')} />
            {/* Navigation */}
            <AccountNavigation t={t} formatted_joining_date={data?.formatted_joining_date} formatted_last_working_date={data?.formatted_last_working_date} data={data}/>

            <Row className='px-4 mt-4'>
                {/* Emergency Contact 01 */}
                <Col lg={4} md={6} xs={12} className='mb-3 mb-md-4'>
                    <FormLabel className='control-label'>
                        {t('page.emergency_contact_01')}
                    </FormLabel>
                    <div className='user-info-value'>
                        <span>{data?.contact_info?.emergency_contact?.name}</span>&nbsp;{'/'}&nbsp;<span>
                        {data?.contact_info?.emergency_contact?.phone_code != '-' && data?.contact_info?.emergency_contact?.contact_no != '-' ? `+${data?.contact_info?.emergency_contact?.phone_code} ${data?.contact_info?.emergency_contact?.contact_no}` : '-'}

                        </span>
                    </div>
                </Col>

                {/* Emergency Contact 02 */}
                <Col lg={4} md={6} xs={12} className='mb-3 mb-md-4'>
                    <FormLabel className='control-label'>
                        {t('page.emergency_contact_02')}
                    </FormLabel>
                    <div className='user-info-value'>
                        <span>{data?.contact_info?.emergency_contact_2?.name}</span>&nbsp;{'/'}&nbsp;<span>{data?.contact_info?.emergency_contact_2?.phone_code != '-' && data?.contact_info?.emergency_contact_2?.contact_no != '-'
                    ? `+${data?.contact_info?.emergency_contact_2?.phone_code} ${data?.contact_info?.emergency_contact_2?.contact_no}`
                    : '-'}



                        </span>
                    </div>
                </Col>

                {/* Alternate Contact Number */}
                <Col lg={4} md={6} xs={12} className='mb-3 mb-md-4'>
                    <FormLabel className='control-label'>
                        {t('page.alternate_contact_number')}
                    </FormLabel>
                    <div className='user-info-value'>
                        {data?.alternate_contact_phone_code != '-' && data?.alternate_contact_No != '-'
                            ? `+${data.alternate_contact_phone_code} ${data.alternate_contact_No}`
                        : '-'}

                    </div>
                </Col>

                {/* Personal Email */}
                <Col lg={4} md={6} xs={12} className='mb-3 mb-md-4'>
                    <FormLabel className='control-label'>
                        {t('page.view_user_personal_email')}
                    </FormLabel>
                    <div className='user-info-value'>
                        {data?.personal_email}
                    </div>
                </Col>

                {/* Date of Birth */}
                <Col lg={4} md={6} xs={12} className='mb-3 mb-md-4'>
                    <FormLabel className='control-label'>
                        {t('page.view_user_date_of_birth')}
                    </FormLabel>
                    <div className='user-info-value'>
                      {data?.date_of_birth}
                    </div>
                </Col>

                {/* Blood Group */}
                <Col lg={4} md={6} xs={12} className='mb-3 mb-md-4'>
                    <FormLabel className='control-label'>
                        {t('page.view_user_blood_group')}
                    </FormLabel>
                    <div className='user-info-value'>
                       {data?.blood_group}
                    </div>
                </Col>

                {/* Marital Status */}
                <Col lg={4} md={6} xs={12} className='mb-3 mb-md-4'>
                    <FormLabel className='control-label'>
                        {t('page.view_user_marital_status')}
                    </FormLabel>
                    <div className='user-info-value'>
                        {data?.marital_status}
                    </div>
                </Col>

                {/* T-shirt Size */}
                <Col lg={4} md={6} xs={12} className='mb-3 mb-md-4'>
                    <FormLabel className='control-label'>
                        {t('page.t_shirt_size')}
                    </FormLabel>
                    <div className='user-info-value'>
                        {data?.tshirt_size}
                    </div>
                </Col>
            </Row>
             </>) : null}
        </>
    )
}

export default ContactAdditionalInfo
